// JS
import React, { useState, useEffect } from 'react';
import {
  nuqliumDataIndexSeven,
  getInternationalPriceNuqlium,
  swapImg,
  randomString,
  devOrProd
} from '../shared/utils';
import { buildNuqliumProductQuery } from '../shared/logic';

const internationalPrice = getInternationalPriceNuqlium();

// COMP
const ColourSwatches = ({
  data,
  setSku,
  setSupportApi,
  setReset,
  isMobile,
  products
}) => {
  const [pageLoaded, setPageLoaded] = useState(null);
  const [swatchesProductData, setSwatchesProductData] = useState(null);

  useEffect(() => {
    if (products) {
      const getFormData = (object) => {
        const formData = new FormData();
        Object.keys(object).forEach((key) => formData.append(key, object[key]));
        return formData;
      };

      const apiQuery = {
        endPointUrl:
          'https://support.footasylum.co.uk/api/nuqlium-seven/data/' +
          devOrProd +
          '/index.php/?v=' +
          randomString(),
        endPointPrams: getFormData(buildNuqliumProductQuery(products))
      };

      fetch(apiQuery.endPointUrl, {
        method: 'POST',
        body: apiQuery.endPointPrams
      })
        .then((response) => response.json())
        .then((data) => {
          setSwatchesProductData(data.data.products.products);
        });
    } else {
      setSwatchesProductData(null);
    }
  }, [products]);

  const setSkuFunc = (sku) => {
    setSku({
      DataIndex: nuqliumDataIndexSeven(),
      output: 'json',
      pagetype: 'product',
      'settings[pricelist]': internationalPrice,
      'settings[mode]': 'web',
      pagekey: sku
    });
  };

  const scrollTo = (el) => {
    const elLeft = el.offsetLeft + el.offsetWidth;
    const elParentLeft =
      el.parentElement.offsetLeft + el.parentElement.offsetWidth;
    if (elLeft >= elParentLeft + el.parentElement.scrollLeft) {
      el.parentElement.scrollLeft = elLeft - elParentLeft + 50;
    }
  };

  const makeSelected = (sizes) => {
    // console.log(sizes);
    if (sizes.product.productid === data.product.productid) {
      const element = document.getElementById('selected');
      if (element && isMobile && !pageLoaded) {
        scrollTo(element);
        setPageLoaded(true);
      }
      return 'selected';
    } else {
      return '';
    }
  };

  //console.log('prodgroups', data.product.productgroups);
  //console.log('ColourSwatches', swatchesProductData);
  return (
    <>
      {swatchesProductData && (
        <div className="colour-swatches">
          <p className="colour-swatches-title">Colours</p>
          <div className="colour-swatches-scroll-wrapper">
            {swatchesProductData.map((sizes, i) => (
              <a
                role="button"
                aria-pressed={makeSelected(sizes) ? 'true' : 'false'}
                aria-label="Select a colour"
                key={'swatch-key[' + i + ']'}
                className={'swatch-wrapper ' + makeSelected(sizes)}
                id={makeSelected(sizes)}
                style={{
                  background: `url(${swapImg(
                    sizes.product.image,
                    'medium',
                    'small'
                  )})  center center/cover no-repeat`
                }}
                href={sizes.url}
                onClick={(e) => {
                  e.preventDefault();
                  setSkuFunc(sizes.product.productid);
                  setSupportApi(true);
                  setReset(true);
                  // Scroll to main image
                  setTimeout(() => {
                    const el = document.getElementById('header-main');
                    if (el) {
                      const headerHeight = el.offsetHeight;
                      window.scroll({
                        top: headerHeight,
                        behavior: 'smooth'
                      });
                    } else {
                      window.scroll({
                        top: 0,
                        behavior: 'smooth'
                      });
                    }
                  }, 800);
                }}
              >
                {sizes.product.option.onsale && (
                  <div className="sale-tag">
                    <span>Sale</span>
                  </div>
                )}
              </a>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default ColourSwatches;
